module.exports = __webpack_public_path__ + "img/default-avatar.d5f51047.jpg";